module.exports = __webpack_public_path__ + "static/media/icon_list_on.dc1977f9.svg";